"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassEditPath = exports.getTabByParamName = exports.TabParamNames = exports.Tabs = void 0;
const react_router_dom_1 = require("react-router-dom");
const ClassManagerIndex_1 = require("./ClassManagerIndex");
var Tabs;
(function (Tabs) {
    Tabs[Tabs["General"] = 0] = "General";
    Tabs[Tabs["MainModules"] = 1] = "MainModules";
    Tabs[Tabs["ExtraModules"] = 2] = "ExtraModules";
    Tabs[Tabs["Users"] = 3] = "Users";
})(Tabs || (exports.Tabs = Tabs = {}));
exports.TabParamNames = {
    [Tabs.General]: 'general',
    [Tabs.MainModules]: 'main-modules',
    [Tabs.ExtraModules]: 'extra-modules',
    [Tabs.Users]: 'users'
};
const getTabByParamName = ({ tabName, isAddClassModuleFeatureEnabled, isUsersTabEnabled }) => {
    if (!isUsersTabEnabled || !isAddClassModuleFeatureEnabled || tabName === '') {
        Tabs.General;
    }
    const tabNameIndex = Object.values(exports.TabParamNames).indexOf(tabName);
    return tabNameIndex > -1 ? Number(tabNameIndex) : Tabs.General;
};
exports.getTabByParamName = getTabByParamName;
const getClassEditPath = (classId, tab) => {
    return (0, react_router_dom_1.generatePath)(ClassManagerIndex_1.EDIT_CLASS_ROUTE, {
        id: classId,
        tabName: exports.TabParamNames[tab]
    });
};
exports.getClassEditPath = getClassEditPath;
